module.exports = __webpack_public_path__ + "img/comprehensiveControl.d8918fd5.png";